var URLLoaderDataFormat = (function () {
    function URLLoaderDataFormat() {
    }
    return URLLoaderDataFormat;
}());
export { URLLoaderDataFormat };
/**
 * TEXT
 * @type {string}
 */
URLLoaderDataFormat.TEXT = "text";
/**
 * Variables / Value Pairs
 * @type {string}
 */
URLLoaderDataFormat.VARIABLES = "variables";
/**
 *
 * @type {string}
 */
URLLoaderDataFormat.BLOB = "blob";
/**
 *
 * @type {string}
 */
URLLoaderDataFormat.ARRAY_BUFFER = "arraybuffer";
/**
 *
 * @type {string}
 */
URLLoaderDataFormat.BINARY = "binary";



// WEBPACK FOOTER //
// ../dist/lib/net/URLLoaderDataFormat.js